import React from 'react';
import PageHero from '../common/PageHero';
import { useTranslation } from 'react-i18next';

const ProjectsHero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageHero
      eyebrow={t('projectsSection.hero.eyebrow')}
      title={t('projectsSection.hero.title')}
      description={t('projectsSection.hero.description')}
      typedTitle
    />
  );
};

export default ProjectsHero;
